module.exports = __webpack_public_path__ + "img/turang.69f82945.png";